var _g;
import * as React from "react";
function SvgIconEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-731 -458) translate(97 396) translate(616 24) translate(0 24) translate(18 14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#586179",
    d: "M17.986 12.708c.192 0 .347.171.347.382v1.528c0 .211-.155.382-.347.382H2.014c-.192 0-.347-.17-.347-.382V13.09c0-.21.155-.382.347-.382zm0-6.875c.192 0 .347.171.347.382v1.528c0 .211-.155.382-.347.382H2.014c-.192 0-.347-.17-.347-.382V6.215c0-.21.155-.382.347-.382z",
    transform: "translate(-731 -458) translate(97 396) translate(616 24) translate(0 24) translate(18 14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquals);
export default __webpack_public_path__ + "static/media/icon-equals.3614ab5b.svg";
export { ForwardRef as ReactComponent };